
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons/[lesson]",
      function () {
        return require("private-next-pages/lessons/[lesson]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons/[lesson]"])
      });
    }
  